import React, { useState } from "react";
// import axios from 'axios';
import CtaSection from "../../components/Common/CtaSection";
import bannerbg from "../../assets/images/resources/cta-one-bg-img.jpg";
import shapeImageUrl from "../../assets/images/shapes/cta-one-shape-1.png";
import ContactMainImg from "../../assets/images/resources/contact-two-img-1.jpg";
// Add Toastify imports
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactMain = () => {
  // Form state
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/contact-forms/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        },
      );
      if (response.ok) {
        toast.success("Your message has been sent!");
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {/* Toastify container */}
      <ToastContainer />
      {/*Contact One Start*/}
      <section className="contact-one">
        <div className="container">
          <div className="text-center section-title">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Contact us</span>
            </div>
            <h2 className="section-title__title">Get in Touch With Us</h2>
          </div>
          <div className="contact-one__inner">
            <ul className="contact-one__contact-list list-unstyled">
              <li>
                <div className="icon">
                  <span className="icon-call" />
                </div>
                <div className="content">
                  <h3>Let's Talk</h3>
                  <p>
                    Phone: <a href="tel:+919983333188">+91-9983333188</a>,{" "}
                    <a href="tel:+919983333144">+91-9983333144</a>
                  </p>
                </div>
              </li>
              <li
                style={{ display: "flex", gap: "1rem", alignItems: "center" }}
              >
                <div className="icon" style={{ flexShrink: 0 }}>
                  <span className="icon-location location-icon" />
                </div>
                <div className="content">
                  <h3>Address</h3>
                  <p>
                    Sunrising Cinevision
                    <br />
                    4VQ8+J9R Delhi Chandwaji, Express Highway, Delhi - Ajmer
                    Hwy, Sar, Bilonchi,
                    <br />
                    Rajasthan, 303805
                    <br />
                  </p>
                </div>
              </li>
              <li>
                <div className="icon">
                  <span className="icon-envolop email-icon" />
                </div>
                <div className="content">
                  <h3>Send us email</h3>
                  <p>
                    <a href="mailto:info@sunrisingcinevisionacademy.in">
                      info@sunrisingcinevisionacademy.in
                    </a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/*Contact One End*/}
      {/*Contact Two Start*/}
      <section className="contact-two">
        <div className="container">
          <div className="row">
            <div className="col-xl-7">
              <div className="contact-two__left">
                <div className="text-left section-title">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">Contact</span>
                  </div>
                  <h2 className="section-title__title">Get Touch Here</h2>
                </div>
                <form
                  className="contact-form-validated contact-two__form"
                  noValidate="novalidate"
                  onSubmit={handleSubmit}
                >
                  <div className="row">
                    <div className="col-xl-6 col-lg-6">
                      <div className="contact-two__input-box">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          required
                          value={form.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                      <div className="contact-two__input-box">
                        <input
                          type="email"
                          name="email"
                          placeholder="E-mail"
                          required
                          value={form.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    {/* Add phone field */}
                    <div className="col-xl-12 col-lg-12">
                      <div className="contact-two__input-box">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Phone"
                          required
                          value={form.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="contact-two__input-box text-message-box">
                        <textarea
                          name="message"
                          placeholder="Message"
                          value={form.message}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className=" col-xl-12">
                      <div className="contact-two__btn-box">
                        <button
                          type="submit"
                          className="thm-btn contact-two__btn"
                          disabled={loading}
                        >
                          {loading ? "Submitting..." : "Submit Now"}
                          <span />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="result" />
              </div>
            </div>
            <div className="hidden col-xl-5 xl:block">
              <div className="contact-two__right">
                <div className="contact-two__img">
                  <img src={ContactMainImg} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*Contact Two End*/}
      {/*Google Map Start*/}
      <section className="google-map-one google-map-two">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3550.4083527283615!2d75.86951047490308!3d27.143439250138133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x28b25bb25cb51c4f%3A0x580621c1bd8a32ba!2sSunrising%20Cinevision%20Academy!5e0!3m2!1sen!2sin!4v1744864380654!5m2!1sen!2sin"
          className="google-map__one"
          width="600"
          height="450"
          allowFullScreen=""
          title="Google Map showing Costco Wholesale location"
        />
      </section>
      {/*Google Map End*/}

      {/*cta-section */}
      <CtaSection
        breadcrumbsImg={bannerbg}
        shapeImageUrl={shapeImageUrl}
        title="Need any help? contact us!"
        text="Need help?"
        phoneNumber=" 9983333188"
      />
      {/*cta-section end */}
    </React.Fragment>
  );
};

export default ContactMain;
